import { useState } from 'react';

interface InputProps {
  id?: string;
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  type?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
}

export default function Input({ id, label, placeholder, value, onChange, error, type = 'text', disabled = false, autoFocus, maxLength }: InputProps) {
  const [focused, setFocused] = useState(false);

  return (
    <div className="w-full">
      {label && <label htmlFor={id} className="block text-sm font-medium font-sans text-text-secondary mb-2">{label}</label>}
      <input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        maxLength={maxLength}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className={`w-full px-4 py-3.5 rounded-xl bg-input-bg border-2 text-base font-sans text-text-primary placeholder:text-text-muted outline-none transition-colors ${
          error ? 'border-error' : focused ? 'border-primary' : 'border-border'
        } ${disabled ? 'opacity-50' : ''}`}
      />
      {error && <p className="mt-2 text-sm text-error font-sans">{error}</p>}
    </div>
  );
}
